const GAP_PX = 4;

const sumWithGaps = (widths: number[]) => {
  if (widths.length === 0) {
    return 0;
  }
  return (
    widths.reduce((sum, width) => sum + width, 0) + GAP_PX * (widths.length - 1)
  );
};

export function calculateSegmentVisibleCount({
  itemWidths,
  moreWidth,
  availableWidth,
  maxItemsToDisplay,
}: {
  itemWidths: number[];
  moreWidth: number;
  availableWidth: number;
  maxItemsToDisplay?: number;
}): number {
  if (itemWidths.length === 0) {
    return 0;
  }

  const maxAllowed =
    maxItemsToDisplay === undefined
      ? itemWidths.length
      : Math.min(maxItemsToDisplay, itemWidths.length);

  if (availableWidth <= 0) {
    return maxAllowed;
  }

  for (let count = maxAllowed; count >= 1; count -= 1) {
    const needsMore = count < itemWidths.length;
    const widths = itemWidths.slice(0, count);
    if (needsMore) {
      widths.push(moreWidth);
    }
    if (sumWithGaps(widths) <= availableWidth) {
      return count;
    }
  }

  return 1;
}
